import {lazyRegister} from "@/Core/lazyRegister";

lazyRegister.directive('productLinkTag', [
    '$rootScope',
    function ($rootScope) {
        return {
            restrict: 'E',
            template: `<div class="flex items-center gap-1">
                            <a class="focus:outline-0! text-link! hover:text-blue-700! focus:text-blue-700!" ng-href="{{generatedUrl}}" title="{{displayTitle}}" target="_blank" ng-transclude></a> 
                            <i ng-if="!hideIcon" class="fa-solid fa-arrow-up-right-from-square text-xs"></i>
                        </div>`,
            replace: true,
            transclude: true,
            scope: {
                number: '<',
                countryId: '<',
                colorCode: '<?',
                hideIcon: '<?',
                title: '@'
            },
            link: function (scope) {
                const formatLink = function (number, countryId, colorCode?: string) {
                    if (!number) return "";
                    const sku = number.substring(0, 5) + "-" + (number.substring(5) || "");
                    const countries = $rootScope.countries || [];
                    const country = countries.find(x => x.Id == countryId);
                    const domain = country
                        ? "https://" + country.DomainName.split(',')[0]
                        : "https://www.mascotwebshop.dk"

                    return `${domain}/identifier/${sku}${!!colorCode ? '?color=' + colorCode : ''}`;
                };

                scope.$watchGroup([
                    'number',
                    'countryId',
                    'colorCode',
                    'title'
                ], function () {
                    scope.generatedUrl = formatLink(scope.number, scope.countryId, scope.colorCode);
                    scope.displayTitle = scope.title || "Open in shop";
                });
            }
        };
    }
]);